module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av476-8effd627bba80ef7aceb133b37e5755e.jpg";